import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Order modes the header can announce; null means a normal sale. */
export type OrderMode = 'quotation' | 'wholesale' | 'delete' | 'offer' | null;

const MODE_META: Record<Exclude<OrderMode, null>, { label: string; icon: string }> = {
  quotation: { label: 'Quotation', icon: 'pi pi-file-edit' },
  wholesale: { label: 'Wholesale', icon: 'pi pi-shopping-bag' },
  delete: { label: 'Delete mode', icon: 'pi pi-trash' },
  offer: { label: 'Offer group', icon: 'pi pi-tags' },
};

/**
 * ModeIndicatorComponent
 *
 * Presentational chip in the POS header that names the active order mode.
 * Renders nothing for a normal sale. Colour comes from the --mode-* tokens.
 */
@Component({
  selector: 'app-mode-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mode-indicator.component.html',
  styleUrls: ['./mode-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModeIndicatorComponent {
  @Input() mode: OrderMode = null;

  get meta() {
    return this.mode ? MODE_META[this.mode] : null;
  }
}
